// src/services/api.js
import axios from 'axios';

// ⚠️ URL forcée en dur pour la production
const API_URL = 'https://madadline.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/* ============ UTILISATEUR ============ */
export async function getUserData() {
  const token = localStorage.getItem('auth_token');
  if (!token) return null;
  try {
    const response = await api.get('/user');
    return response.data;
  } catch (error) {
    console.error('Erreur getUserData:', error);
    return null;
  }
}

/* ============ PRODUITS ============ */
export const getFeaturedProducts = async () => {
  try {
    // ✅ Route correcte : /products/new existe dans routes/api.php
    const { data } = await api.get('/products/new');
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error('getFeaturedProducts error:', err);
    return [];
  }
};

export const getProducts = async (params = {}) => {
  try {
    const { data } = await api.get('/products', { params });
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

export const getProductBySlug = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};


export const searchProducts = async (q, lang = 'fr') => {
  try {
    const { data } = await api.get('/products/search', {
      params: { q, lang },
    });

    // Accepter un tableau ou une réponse contenant les produits
    const products = Array.isArray(data)
      ? data
      : Array.isArray(data?.products)
        ? data.products
        : [];

    return products.map((p) => {
      let image = p.image;

      if (typeof image === 'string' && image.trim() !== '') {
        image = image.trim();

        if (/^https?:\/\//i.test(image)) {
          try {
            const url = new URL(image);

            // Corriger l'ancien chemin qui renvoie une erreur 500
            if (url.pathname.startsWith('/images/')) {
              const filename = url.pathname.split('/').pop();

              image = `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`;
            }
          } catch (error) {
            console.error('URL image invalide :', image);
            image = null;
          }
        } else {
          // Accepter images/nom.jpg ou simplement nom.jpg
          const filename = image.split('/').pop();

          image = `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`;
        }
      } else {
        image = null;
      }

      return {
        ...p,
        image,
      };
    });
  } catch (err) {
    console.error(
      'Erreur searchProducts :',
      err.response?.data || err.message
    );
    return [];
  }
};


/* ============ CATÉGORIES ============ */
export const getCategories = async () => {
  try {
    const { data } = await api.get('/categories');
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error('getCategories error:', err);
    return [];
  }
};

/* Alias */
export const getCategoriesFromDb = getCategories;

/* ✅ CATÉGORIES AVEC IMAGES — vérifié, fonctionne */

/* ============ CATÉGORIES AVEC IMAGES ============ */

/* ============ CATÉGORIES AVEC IMAGES ============ */
export const getCategoriesWithImages = async () => {
  try {
    const { data } = await api.get('/categories-with-images');

    if (!Array.isArray(data)) {
      console.error(
        'La réponse des catégories n’est pas un tableau :',
        data
      );
      return [];
    }

    const categories = data.map((category) => {
      let image = category.image;

      if (typeof image === 'string' && image.trim() !== '') {
        image = image.trim();

        try {
          let filename;

          if (/^https?:\/\//i.test(image)) {
            const url = new URL(image);

            // Corriger les anciennes URL /images/nom.jpg
            if (
              url.hostname === 'madadline.com' ||
              url.hostname === 'www.madadline.com'
            ) {
              filename = url.pathname.split('/').filter(Boolean).pop();
              image = filename
                ? `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`
                : null;
            } else {
              // Conserver les URL d'autres domaines
              image = url.href;
            }
          } else {
            // Gérer images/nom.jpg, /images/nom.jpg ou nom.jpg
            filename = image.split('/').filter(Boolean).pop();

            image = filename
              ? `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`
              : null;
          }
        } catch (error) {
          console.error('URL image invalide :', image, error);
          image = null;
        }
      } else {
        image = null;
      }

      return {
        ...category,
        image,
      };
    });

    console.log('Catégories avec URL des images corrigées :', categories);

    return categories;
  } catch (err) {
    console.error(
      'Erreur getCategoriesWithImages :',
      err.response?.data || err.message
    );
    return [];
  }
};



export const getCategoryProducts = async (slug, params = {}) => {
  try {
    const { data } = await api.get(`/categories/${slug}/products`, { params });
    return data;
  } catch {
    return [];
  }
};

/* ============ AVIS ============ */
export const getReviews = async (limit = 4) => {
  try {
    // ✅ Route correcte : /avis existe dans routes/api.php
    const { data } = await api.get('/avis', { params: { limit } });
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error('getReviews error:', err);
    return [];
  }
};

/* ============ COMMANDES ============ */
export const createOrder = async (orderData) => {
  const { data } = await api.post('/orders', orderData);
  return data;
};

export const trackOrder = async (orderNumber, phone) => {
  const { data } = await api.get(`/orders/${orderNumber}`, { params: { phone } });
  return data;
};

/* ============ NEWSLETTER ============ */
export const subscribeNewsletter = async (phone, lang = 'fr') => {
  const { data } = await api.post('/newsletter', { phone, lang });
  return data;
};

/* ============ LIVRAISON ============ */
export const getDeliveryCities = async () => {
  try {
    const { data } = await api.get('/delivery/cities');
    return data;
  } catch {
    return [];
  }
};

export default api;